






















































import Vue from 'vue'
import { mapGetters } from 'vuex'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

extend('username', {
  ...required,
  message: 'Fill with your username or email address!',
})
extend('password', {
  ...required,
  message: 'Password is required!',
})

export default Vue.extend({
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  name: 'LoginPage',
  data() {
    return {
      loading: false,
      model: {
        username: '',
        password: '',
        remember: false,
      },
    }
  },
  computed: {
    ...mapGetters(['version']),
  },
  methods: {
    async login() {
      this.loading = true
      try {
        const { username, password } = this.model
        await this.$store.dispatch('user/login', {
          username,
          password,
        })
      } catch (response) {
        //
      }

      this.loading = false
    },
  },
})
